import { Theme } from '@mui/material/styles';
import { amnMUITheme } from 'styles/global-styles';

function hexToRgb(hex: string) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    }
    : null;
}

export function accessibleFontColor(bgColorInHex: string) {
  let bgColorAsRgb = hexToRgb(bgColorInHex);
  if (bgColorAsRgb === null) {
    return bgColorInHex
  }

  if ((bgColorAsRgb.r * 0.299 + bgColorAsRgb.g * 0.587 + bgColorAsRgb.b * 0.114) > 176) {
    return (`rgb(4, 51, 88)`);
  } else {
    return (`rgb(255,255,255)`);
  }
}

export const colorToFill = (customColor?: string, customTheme?: Theme) => {
  const theme = customTheme != null ? customTheme : amnMUITheme;
  const color = customColor != null ? customColor : 'primary';
  switch (color) {
    case 'primary':
      return theme.palette.primary.main;
    case 'secondary':
      return theme.palette.secondary.main;
    case 'success':
      return theme.palette.success.main;
    case 'warning':
      return theme.palette.warning.main;
    case 'error':
      return theme.palette.error.main;
    default:
      return color;
  }
};
